export const color = ['#FF1177', '#228DFF', '#FFDD1B', '#B6FF00', '#FF9900', '#ff00de']
export const animation = ['없음', 'bounce', 'flash', 'pulse', 'rubberBand', 'shake', 'swing', 'tada', 'wobble', 'jello']



// WEBPACK FOOTER //
// ./src/option/options.js